export default __webpack_public_path__ + "static/media/shield.d8b2c5c1.svg";